<template>
  <div class="pt-labels" :class="{ 'pt-separator': props.separator }">
    <template v-if="Array.isArray(props.items)">
      <div
        v-for="item in props.items"
        :key="item.label"
        class="pt-labels__item"
        :class="`${
          'pt-labels__item--' +
          labelType +
          ' font-' +
          weightType +
          ' text-' +
          textSize +
          ' font-' +
          fontType
        } ${props.toSearch !== '' ? 'clickable' : ''}`"
        @[ev]="setFilter"
        v-text="item.label || item.date || item"
      />
    </template>
    <template v-else-if="typeof props.items === 'object' && props.items !== null">
      <div
        class="pt-labels__item"
        :class="`${
          'pt-labels__item--' +
          props.labelType +
          ' font-' +
          props.weightType +
          ' text-' +
          props.textSize +
          ' font-' +
          props.fontType
        } ${props.toSearch !== '' ? 'clickable' : ''}`"
        @[ev]="setFilter"
        v-text="props.items.label"
      />
    </template>
    <template v-else>
      <div
        v-if="props.items !== 'Hibrido' && props.items !== 'Hybrid' && props.items !== 'Onsite'"
        class="pt-labels__item"
        :class="`${
          'pt-labels__item--' +
          props.labelType +
          ' font-' +
          props.weightType +
          ' text-' +
          props.textSize +
          ' font-' +
          props.fontType
        } ${props.toSearch !== '' ? 'clickable' : ''}`"
        @[ev]="setFilter"
        v-text="props.items"
      />
      <div
        v-if="props.items === 'Hibrido' || props.items === 'Hybrid' || props.items === 'Onsite'"
        class="pt-labels__item"
        :class="`${
          'pt-labels__item--' +
          props.labelType +
          ' font-' +
          props.weightType +
          ' text-' +
          props.textSize +
          ' font-' +
          props.fontType
        } ${props.toSearch !== '' ? 'clickable' : ''}`"
        @[ev]="setFilter"
        v-text="$t('calendar.presential')"
      />
      <div
        v-if="props.items === 'Hibrido' || props.items === 'Hybrid'"
        class="pt-labels__item"
        :class="`${
          'pt-labels__item--' +
          props.labelType +
          ' font-' +
          props.weightType +
          ' text-' +
          props.textSize +
          ' font-' +
          props.fontType
        } ${props.toSearch !== '' ? 'clickable' : ''}`"
        @[ev]="setFilter"
        v-text="$t('calendar.web')"
      />
    </template>
  </div>
</template>

<script setup>
import { SEARCH_RESULTS_URL } from '@/utils/enums';
const router = useRouter();
const { createSearchQueryParameters, createRefinementListParameters } = useInstantSearch();

const props = defineProps({
  items: {
    type: [Number, Array, Object, String],
    default: () => ''
  },
  separator: {
    type: Boolean,
    default: false
  },
  labelType: {
    type: String,
    default: 'arable',
    validator: value =>
      value.match(
        /(arable|blue|gray|blue-light|gray-light|expired|red|transparent|white|orange|text-gray|earth|orange-bg|black|text-gray-dark|text-gray-light|text-red)/
      )
  },
  weightType: {
    type: String,
    default: 'semibold',
    validator: value => value.match(/(extralight|light|normal|medium|semibold|bold|ubuntu)/)
  },
  textSize: {
    type: String,
    default: 'sm',
    validator: value => value.match(/(xs|sm|base|lg|xl|2xl|3xl|4xl)/)
  },
  fontType: {
    type: String,
    default: 'sans',
    validator: value => value.match(/(sans|ubuntu)/)
  },
  toSearch: {
    type: String,
    default: ''
  },
  facetSearch: {
    type: String,
    default: 'tags_facets'
  },
  ev: {
    type: String,
    default: 'click',
    validator: value => value.match(/(click|mouseup)/)
  }
});

const setFilter = filterValue => {
  filterValue.preventDefault();
  if (props.toSearch !== '') {
    const { textContent: filterText } = filterValue.target;
    const paramsSearch = createSearchQueryParameters(
      props.toSearch,
      '',
      createRefinementListParameters(props.facetSearch, filterText)
    );
    navigateTo(`${SEARCH_RESULTS_URL}${paramsSearch}`);
  }
};
</script>
<style src="./style.scss" lang="scss" />
